module.exports = __webpack_public_path__ + "img/path.adb497a0.png";